var map = {
	"./CA/seal.png": 1499,
	"./CA/seal.svg": 1029,
	"./CA/seal_color.png": 1500,
	"./CA/seal_reversed.svg": 1030,
	"./CA/sos-logo.png": 1501,
	"./ID/seal.png": 1502,
	"./ID/seal.svg": 1031,
	"./ID/seal_color.png": 1503,
	"./ID/seal_reversed.svg": 1032,
	"./ID/sos-logo.png": 1504,
	"./MT/mt-sos-logo.png": 1505,
	"./MT/seal.png": 1506,
	"./MT/seal.svg": 1033,
	"./MT/seal_color.png": 1507,
	"./MT/seal_white.png": 1508,
	"./ND/seal.svg": 1034,
	"./SOS/seal.svg": 1035
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;



//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals ^\.\/.*$
// module id = 216
// module chunks = 0